"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildSupersededEvent = exports.BuildAbandonedEvent = exports.ResultsOpenedEvent = exports.BuildDeliveredEvent = exports.BomReviewSentEvent = exports.BomResolutionSummaryEvent = exports.NetlistErrorsAcceptedEvent = exports.NetlistGenerationFailedEvent = exports.NetlistValidationCompletedEvent = exports.BuildParseResolutionEvent = exports.BuildParseFailedEvent = exports.BuildUploadValidationFailedEvent = exports.BuildUploadAcceptedEvent = exports.BuildStageTransitionedEvent = void 0;
const zod_1 = require("zod");
const event_1 = require("../event");
const build_lifecycle_enums_1 = require("./build-lifecycle-enums");
const netlist_gate_1 = require("../../Types/netlist-gate");
const remediation_1 = require("../../Types/remediation");
const netlist_triage_1 = require("../../Types/netlist-triage");
exports.BuildStageTransitionedEvent = (0, event_1.createEventClass)('BuildStageTransitionedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    fromStatus: zod_1.z.string(),
    toStatus: zod_1.z.string(),
    statusMessage: zod_1.z.string().optional(),
    actorUserId: zod_1.z.string().optional(),
    trigger: zod_1.z.nativeEnum(build_lifecycle_enums_1.BuildTransitionTrigger),
}));
exports.BuildUploadAcceptedEvent = (0, event_1.createEventClass)('BuildUploadAcceptedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    userId: zod_1.z.string(),
    declaredTool: zod_1.z.string().optional(),
}));
exports.BuildUploadValidationFailedEvent = (0, event_1.createEventClass)('BuildUploadValidationFailedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    reason: zod_1.z.nativeEnum(build_lifecycle_enums_1.UploadValidationFailureReason),
    errorCount: zod_1.z.number().int().nonnegative(),
    errors: zod_1.z.array(zod_1.z.string()),
    declaredTool: zod_1.z.string().optional(),
}));
exports.BuildParseFailedEvent = (0, event_1.createEventClass)('BuildParseFailedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    phase: zod_1.z.nativeEnum(build_lifecycle_enums_1.ParseFailurePhase),
    reason: zod_1.z.string(),
    remediationOwner: zod_1.z.nativeEnum(remediation_1.RemediationOwner).optional(),
    remediationSummary: zod_1.z.string().optional(),
    remediationSteps: zod_1.z.array(zod_1.z.string()).optional(),
    triage: netlist_triage_1.NetlistTriagePointerSchema.optional(),
}));
exports.BuildParseResolutionEvent = (0, event_1.createEventClass)('BuildParseResolutionEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    action: zod_1.z.nativeEnum(build_lifecycle_enums_1.ParseResolutionAction),
    projectModelId: zod_1.z.string().optional(),
}));
exports.NetlistValidationCompletedEvent = (0, event_1.createEventClass)('NetlistValidationCompletedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    outcome: zod_1.z.nativeEnum(build_lifecycle_enums_1.NetlistValidationOutcome),
    errorCount: zod_1.z.number().int().nonnegative(),
    errorsByType: zod_1.z.record(zod_1.z.string(), zod_1.z.number().int().nonnegative()).optional(),
    netlistSource: zod_1.z.nativeEnum(netlist_gate_1.NetlistSource).optional(),
    remediationOwner: zod_1.z.nativeEnum(remediation_1.RemediationOwner).optional(),
    remediationSummary: zod_1.z.string().optional(),
    remediationSteps: zod_1.z.array(zod_1.z.string()).optional(),
    triage: netlist_triage_1.NetlistTriagePointerSchema.optional(),
}));
exports.NetlistGenerationFailedEvent = (0, event_1.createEventClass)('NetlistGenerationFailedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    failureCode: zod_1.z.nativeEnum(remediation_1.NetlistGenerationFailureCode).optional(),
    remediationOwner: zod_1.z.nativeEnum(remediation_1.RemediationOwner),
    remediationSummary: zod_1.z.string(),
    remediationSteps: zod_1.z.array(zod_1.z.string()),
    reason: zod_1.z.string(),
    triage: netlist_triage_1.NetlistTriagePointerSchema.optional(),
}));
exports.NetlistErrorsAcceptedEvent = (0, event_1.createEventClass)('NetlistErrorsAcceptedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    acceptedByUserId: zod_1.z.string(),
    workflowId: zod_1.z.string(),
}));
exports.BomResolutionSummaryEvent = (0, event_1.createEventClass)('BomResolutionSummaryEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    resolutionTypeCounts: zod_1.z.record(zod_1.z.string(), zod_1.z.number().int().nonnegative()),
    unresolvedModuleCount: zod_1.z.number().int().nonnegative(),
    dispatchedModuleCount: zod_1.z.number().int().nonnegative(),
}));
exports.BomReviewSentEvent = (0, event_1.createEventClass)('BomReviewSentEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    bomItemCount: zod_1.z.number().int().nonnegative(),
    reviewRowCount: zod_1.z.number().int().nonnegative(),
    importantRowCount: zod_1.z.number().int().nonnegative(),
    noDatasheetRowCount: zod_1.z.number().int().nonnegative(),
}));
exports.BuildDeliveredEvent = (0, event_1.createEventClass)('BuildDeliveredEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    deliveredByUserId: zod_1.z.string().optional(),
}));
exports.ResultsOpenedEvent = (0, event_1.createEventClass)('ResultsOpenedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    openedByUserId: zod_1.z.string(),
    source: zod_1.z.nativeEnum(build_lifecycle_enums_1.ResultsOpenSource),
    deliveryLinkToken: zod_1.z.string().optional(),
    firstOpen: zod_1.z.boolean(),
}));
exports.BuildAbandonedEvent = (0, event_1.createEventClass)('BuildAbandonedEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    abandonedByUserId: zod_1.z.string().optional(),
    wasSuperseded: zod_1.z.boolean(),
}));
exports.BuildSupersededEvent = (0, event_1.createEventClass)('BuildSupersededEvent', zod_1.z.object({
    buildId: zod_1.z.string(),
    projectId: zod_1.z.string().optional(),
    organizationId: zod_1.z.string().optional(),
    supersededByBuildId: zod_1.z.string(),
}));
//# sourceMappingURL=build-lifecycle-events.js.map